module.exports = __webpack_public_path__ + "img/little-asymmetry-left.d3823f34.svg";